import type { FC } from "react";
import {
  getRequirementStatus,
  PASSWORD_REQUIREMENTS,
  type RequirementStatus,
} from "@/pages/auth/NewPasswordPage/passwordRequirements";
import styles from "@/pages/auth/NewPasswordPage/PasswordRequirementsList.module.css";

interface PasswordRequirementsListProps {
  isValidated: boolean;
  password: string;
}

const ICON_NAME_BY_STATUS: Record<RequirementStatus, string> = {
  met: "pi-check-circle",
  neutral: "pi-minus-circle",
  unmet: "pi-times-circle",
};

const ICON_CLASS_BY_STATUS: Record<RequirementStatus, string> = {
  met: styles.iconMet,
  neutral: styles.iconNeutral,
  unmet: styles.iconUnmet,
};

const PasswordRequirementsList: FC<PasswordRequirementsListProps> = ({
  isValidated,
  password,
}) => (
  <ul aria-live="polite" className={styles.list}>
    {PASSWORD_REQUIREMENTS.map((requirement) => {
      const status = getRequirementStatus(
        requirement.isMet(password),
        isValidated
      );
      return (
        <li key={requirement.key} className={styles.item}>
          <i
            aria-hidden="true"
            className={`pi ${ICON_NAME_BY_STATUS[status]} ${ICON_CLASS_BY_STATUS[status]}`}
          />
          {requirement.label}
        </li>
      );
    })}
  </ul>
);

export default PasswordRequirementsList;
